import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from '../shared/primeng.module';
import { MaterialModuleModule } from '../material-module/material-module/material-module.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OneToOneChatComponent } from './one-to-one-chat/one-to-one-chat.component';
import { GroupChatComponent } from './group-chat/group-chat.component';
import { CollaborationfeaturesRouting } from './collaboration-features-routing.module';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { HomeModule } from '../home/home.module';
import { VideoCallsSharingComponent } from './video-calls-sharing/video-calls-sharing.component';
import { FileSharingComponent } from './file-sharing/file-sharing.component';
import { CalenderPageComponent } from './calender-page/calender-page.component';



@NgModule({
  declarations: [
    OneToOneChatComponent,
    GroupChatComponent,
    VideoCallsSharingComponent,
    FileSharingComponent,
    CalenderPageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    PrimengModule,
    MaterialModuleModule,
    MatTooltipModule,
    CollaborationfeaturesRouting,
    CommonComponentsModule,
    HomeModule,
    CommonComponentsModule
  ]
})
export class CollaborationFeaturesModule { }
